import React from 'react'
import moment from 'moment'
import { Button, CircularProgress } from '@material-ui/core'
import Tooltip from '../../components/Tooltip/Tooltip'
import {
  actions
} from '../listView.reducer'
import { ListViewDispatchContext, ListViewStateContext } from '../listView.context'
import sortBy from 'lodash/sortBy'

import { massProcessingApi } from '@atheneum/api'

const getStatus = item => [item.data?.status]
const printRecipient = status =>
  status.recipient ? ` (${status.recipient})` : ''
const getStatusText = status => {
  switch (status.status) {
    case 'EMAIL_ERROR':
      return (
        <>
          <div>
            An error occured while sending email{printRecipient(status)}
          </div>
          <div>{status.description}</div>
        </>
      )
    case 'EMAIL_SEND':
      return 'Email was sent to the user' + printRecipient(status)
    case 'EMAIL_SENT':
      return 'Email was sent for processing' + printRecipient(status)
    case 'EMAIL_BOUNCE':
      return 'Email message bounced' + printRecipient(status)
    case 'EMAIL_FAIL':
      return 'Sending email has failed' + printRecipient(status)
    case 'EMAIL_DELIVERY':
      return 'Email was delivered to recipient' + printRecipient(status)
    case 'EMAIL_OPEN':
      return 'Email was opened by recipient' + printRecipient(status)
    case 'UNSUBSCRIBED':
      return 'Unsubscribed'
    case 'EMAIL_CLICK':
      return 'Link in the email was clicked' + printRecipient(status)
    case 'INTERESTED':
      return 'Expert interested'
    case 'NOT_INTERESTED':
      return 'Expert not interested'
    case 'SURVEY_PARTIAL':
      return 'Survey status set to partial'
    case 'SURVEY_TERMINATED':
      return 'Survey status set to terminated'
    case 'SURVEY_OVERQUOTA':
      return 'Survey status set to overquota'
    case 'SURVEY_QUALIFIED':
      return 'Survey status set to qualified'
    default:
      return status.description
  }
}

const TooltipContent = (statusObj, item) => {
  return !statusObj ? (
    <div>
      <CircularProgress
        style={{
          color: '#fff',
          width: '25px',
          height: '25px'
        }}
      />
    </div>
  ) : (
    <div style={{ minWidth: 100 }}>
      {item.data?.status?.description !== 'queued' &&
        item.data.isPartiallySent && (
          <div>
            <strong>Some emails were not sent due to DNC blocking</strong>
          </div>
        )}
      {statusObj.map(s => (
        <div style={{ marginBottom: 8 }}>
          <div>{getStatusText(s)}</div>
          <div style={{ opacity: 0.7, fontSize: 10, marginTop: -5 }}>
            {moment(s.timestamp).format('ddd, MMM Do HH:mm')}
          </div>
        </div>
      ))}
    </div>
  )
}

const AllStatusTooltip = ({ item, children }) => {
  const dispatch = React.useContext(ListViewDispatchContext)
  const state = React.useContext(ListViewStateContext)

  const [status] = getStatus(item, state, dispatch)
  const [statusObj, setStatusObj] = React.useState(null)

  if (!status) return null

  return (
    <div
      style={{
        lineHeight: '33px',
        display: 'flex',
        alignItems: 'center'
      }}
      className="mass-processing--field"
      onMouseEnter={async () => {
        const data = await massProcessingApi.getItemActions(item.id)
        const lastAction = data.find(
          da => da.massActionId === Math.max(...data.map(d => d.massActionId))
        )
        const allStatuses = data
          .map(
            a =>
              a.data.status?.map(s => {
                return { ...s, isLast: lastAction.id === a.id }
              }) || []
          )
          .flat()
        const sortedStatuses = sortBy(allStatuses, ['timestamp'])

        const statuses = sortedStatuses.slice(
          Math.max(sortedStatuses.length - 8, 0)
        )

        setStatusObj(statuses)
      }}>
      <Tooltip wide tooltip={() => TooltipContent(statusObj, item)}>
        <div style={{ color: status.isError ? 'red' : 'inherit' }}>
          {children}
        </div>
      </Tooltip>
    </div>
  )
}

export default ({ item }) => {
  return (
    <AllStatusTooltip item={item}>
      <Status item={item} />
    </AllStatusTooltip>
  )
}

const Status = ({ item }) => {
  const dispatch = React.useContext(ListViewDispatchContext)
  const state = React.useContext(ListViewStateContext)

  const [status] = getStatus(item, state, dispatch)

  if (!status) return null

  if (status.isError) {
    return (
      <div>
        <span style={{ color: 'red' }}>Failed</span>
        <Button
          onClick={async () => {
            const action = await massProcessingApi.getLastAction(item.id)

            if (status.status === 'DNC_ERROR') {
              dispatch({
                type: actions.IGNORE_RULE,
                payload: {
                  listItemId: item.id,
                  actionId: action.id,
                  action
                }
              })
            } else {
              massProcessingApi.retryAction(action.id)
            }
          }}>
          Retry
        </Button>
      </div>
    )
  }
  return (
    <div style={{ display: 'flex', flexFlow: 'column' }}>
      <div style={{ display: 'flex', marginTop: -5 }}>
        <div style={{ color: status.isError ? 'red' : 'inherit' }}>
          {status.followupIndex ? `${status.followupIndex}FU: ` : ''}
          {status.description}
        </div>
        {item.data?.status?.description !== 'queued' &&
          item.data.isPartiallySent && (
            <>
              <Button
                onClick={async () => {
                  const action = await massProcessingApi.getLastAction(item.id)

                  dispatch({
                    type: actions.IGNORE_RULE,
                    payload: {
                      listItemId: item.id,
                      actionId: action.id,
                      action
                    }
                  })
                }}>
                Retry
              </Button>
            </>
          )}
      </div>
      <div style={{ fontSize: 10, marginTop: -20 }}>
        {moment(status.timestamp).format('ddd, MMM Do HH:mm')}
      </div>
    </div>
  )
}
